/** Quêtes (défis de classe programmés par l'admin). */
import type { CreateQuestRequest, Quest, QuestDetails } from '@unity-learning/shared';
import { apiGet, apiRequest } from './client';

export interface QuestParticipation {
  participated: boolean;
  completed: boolean;
  bestScore: number;
}

export interface QuestWithParticipation extends Quest {
  userParticipation?: QuestParticipation;
}

/** Toutes les quêtes actives, la plus récemment activée d'abord, avec la participation de l'utilisateur connecté. */
export function getActiveQuests(): Promise<QuestWithParticipation[]> {
  return apiGet<QuestWithParticipation[]>('/api/quests/active-list').then((quests) => quests ?? []);
}

/** Termine une quête active ou programmée (admin). Renvoie la quête et le message du serveur. */
export async function endQuest(questId: string): Promise<{ quest: Quest; message?: string }> {
  const payload = await apiRequest<Quest>('POST', `/api/quests/${encodeURIComponent(questId)}/end`);
  return { quest: payload.data as Quest, message: payload.message };
}

export function getQuest(questId: string): Promise<QuestWithParticipation> {
  return apiGet<QuestWithParticipation>(`/api/quests/${encodeURIComponent(questId)}`);
}

export function getQuestHistory(): Promise<QuestDetails[]> {
  return apiGet<QuestDetails[]>('/api/quests/history').then((quests) => quests ?? []);
}

export function getQuestDetails(questId: string): Promise<QuestDetails> {
  return apiGet<QuestDetails>(`/api/quests/${encodeURIComponent(questId)}/details`);
}

/** Renvoie la quête créée et le message de confirmation du serveur. */
export async function createQuest(params: CreateQuestRequest): Promise<{ quest: Quest; message?: string }> {
  const payload = await apiRequest<Quest>('POST', '/api/quests/create', params);
  return { quest: payload.data as Quest, message: payload.message };
}
